import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'

import ApiService from './services/api.service'
import TokenService from './services/storage.service'
import UserService from './services/user.service'

import moment from 'moment'
import VeeValidate from 'vee-validate'
import toastr from 'toastr'
import axios from 'axios'
import VueMask from 'v-mask'
import datePicker from 'vue-bootstrap-datetimepicker'
import vSelect from 'vue-select'

import './assets/css/animate.css'
import './assets/css/font-awesome.css'
import './assets/css/toastr.min.css'
import './assets/css/bootstrap.css'
import './assets/css/data-tables.css'
import './assets/css/bootstrap-datetimepicker.css'
// import './assets/css/fullcalendar.css'
// import './assets/css/fullcalendar.print.css'
import './assets/css/style.css'
import './assets/css/custom.scss'
import 'vue-select/dist/vue-select.css'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import i18n from './i18n'

Vue.config.productionTip = false
Vue.config.performance = true

Vue.use( VeeValidate )
Vue.use( VueMask )
Vue.use( Viewer )
Vue.use( datePicker )

Vue.component( 'v-select', vSelect )

toastr.options = {
  'closeButton': true,
  'debug': false,
  'progressBar': true,
  'preventDuplicates': false,
  'positionClass': 'toast-top-right',
  'onclick': null,
  'showDuration': '400',
  'hideDuration': '1000',
  'timeOut': '7000',
  'extendedTimeOut': '1000',
  'showEasing': 'swing',
  'hideEasing': 'linear',
  'showMethod': 'fadeIn',
  'hideMethod': 'fadeOut'
}

Vue.prototype.$moment = moment
Vue.prototype.$toastr = toastr
Vue.prototype.$http = axios

// ApiService.init( 'https://panel.cosmogroup.pl/api/' )
if ( process.env.NODE_ENV === 'production' ) {
  ApiService.init( 'https://panel.cosmogroup.pl/api/' )
} else {
  ApiService.init( 'http://127.0.0.1:8000/api/' )
}

if ( TokenService.getToken() ) {
  ApiService.setHeader()
}

axios.interceptors.response.use(
  response => response,
  error => {
    if ( error.response.status === 401 ) {
        console.log( 'unauthorized, logging out ...' )
        UserService.refreshToken()
          .then( () => ApiService.customRequest( {
              method: error.config.method,
              url: error.config.url,
              data: error.config.data
            } )
          )
          .catch( () => {
            router.replace( '/login' )
          } )
    } else {
      return Promise.reject( error.response )
    }
  }
)

Vue.filter( 'currency', value => {
  const val = ( value / 1 ).toFixed( 2 ).replace( '.', ',' )
  return val.toString().replace( /\B(?=(\d{3})+(?!\d))/g, ' ' )
} )

Vue.directive( 'lazyload', {
  inserted: el => {
    function loadImage() {
      axios( {
          url: `${el.dataset.url}/${ el.dataset.id }`,
          method: 'GET',
          responseType: 'blob'
      } )
      .then( resp => {
          console.log( resp.headers[ 'content-type' ] )
          if ( resp.headers[ 'content-type' ] !== 'application/pdf' ) {
            const url = window.URL.createObjectURL( new Blob( [ resp.data ] ) )
            el.addEventListener( 'load', () => {
              setTimeout( () => el.classList.add( 'loaded' ), 100 )
            } )
            el.addEventListener( 'error', err => console.error( err ) )
            el.src = url
          } else {
            el.src = ''
          }
      } )
    }

    function handleIntersect( entries, observer ) {
      entries.forEach( entry => {
        if ( entry.isIntersecting ) {
          loadImage()
          observer.unobserve( el )
        }
      } )
    }

    function createObserver() {
      const options = {
        root: null,
        threshold: '0'
      }
      const observer = new IntersectionObserver( handleIntersect, options )
      observer.observe( el )
    }
    if ( window.IntersectionObserver ) {
      createObserver()
    } else {
      loadImage()
    }
  }
} )

Vue.mixin( {
  data() {
    return {
      optionsDate: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        locale: document.cookie.lang || 'pl'
      },
      optionsWithTime: {
        format: 'YYYY-MM-DD HH:mm',
        useCurrent: false,
        locale: document.cookie.lang || 'pl'
      }
    }
  }
} )

new Vue( {
  router,
  store,
  i18n,
  render: h => h( App )
} ).$mount( '#app' )
